import type { MyFilesSearchSchema } from "./page-search-schema";

type Props = {
  href: string | undefined;
  itemId: "graphic" | "unknown" | "video" | "website" | number;
} & MyFilesSearchSchema;

export function getFileConfigPayload({
  brandId,
  folder,
  href,
  itemId,
  projectId,
  requestId,
  requestType,
}: Props): MyFilesSearchSchema {
  const payload = { brandId, folder, projectId, requestId, requestType };

  if (
    (href === "brand" && typeof itemId === "number") ||
    itemId === "unknown"
  ) {
    payload.brandId = itemId;
  }

  if (href === "sourcefiles" || href === "archive" || href === "trash") {
    payload.folder = href;
  }

  if (href === "request" && typeof itemId === "number") {
    payload.requestId = itemId;
  }

  if (
    href === "requestType" &&
    (itemId === "graphic" || itemId === "video" || itemId === "website")
  ) {
    payload.requestType = itemId;
  }

  return payload;
}
